import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import Page from '@shell/Page'
import { router } from 'expo-router'
import { useTranslation } from 'react-i18next'

import { SavedOrder } from '@order/hooks/state/orderState'
import Discounts from './Discounts'

export default function SavedOrderDiscounts({ order }: { order: SavedOrder }) {
  const { t } = useTranslation(['ui'])

  return (
    <>
      <Page stage="order">
        <Discounts savedOrderId={order.id} />
      </Page>
      <ButtonsFixed
        buttons={[
          {
            variant: 'filled',
            label: t('ui:checkout'),
            iconEnd: 'arrow-narrow-right',
            onPress: () => router.navigate('/checkout'),
          },
        ]}
      />
    </>
  )
}
